<div class="container">
  <div
    [hidden]="popUpController.hiddenPopUp"
    [class]="'popup ' + popUpController.animationPopUp"
    [ngStyle]="popUpController.popUpConfig.styles">
    <div [appDynamicHost]="popUpController.popUpConfig.component"></div>
  </div>
</div>
